import { Component, ChangeDetectionStrategy } from '@angular/core';


@Component({
	selector: 'alumni-tab-1-part',
	standalone: true,
	templateUrl: './alumni-tab-1.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: [`./alumni-tab-1.part.scss`],
})
export class AlumniTab1Part {
}
